import { render, staticRenderFns } from "./WizardTable.vue?vue&type=template&id=17578526&"
import script from "./WizardTable.vue?vue&type=script&lang=js&"
export * from "./WizardTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports